module.exports = __webpack_public_path__ + "img/left-xxl-me.11a5e70.webp";